export default function Grants() {
  return (
    <section
    id="grants"
      className="relative w-full py-10 flex flex-col items-center min-h-fit"
      style={{ backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
    >
      <div className="max-w-6xl w-full mx-auto px-4 flex flex-col items-center">
        <h2 className="text-5xl font-medium text-black text-center mb-8">Grants</h2>
        <p className="text-lg text-black text-center mb-6 max-w-5xl mx-auto">
          XAO DAO provides grants to support innovative projects and initiatives that benefit the XRPL ecosystem. Members can submit grant proposals, which are reviewed and voted on by the community.
        </p>
        <div className="mt-12 flex flex-col md:flex-row md:overflow-x-auto gap-6 justify-center items-center w-full md:w-[80%]">
          {/* Step 2: Application */}
          <div className="bg-gradient-to-r from-[#1bdfff08] to-[#6777ff08] via-[#0098fb08] via-50 rounded-2xl p-8 w-full max-w-[360px] md:w-[360px] min-h-[280px] relative">
            <div className="absolute border border-[#1bdfff] rounded-2xl inset-0 pointer-events-none"></div>
            <div className="flex items-center justify-center mb-4">
              <span className="text-[#121828] text-xl font-semibold">Application</span>
            </div>
            <p className="text-sm text-[#121828] text-left">Members can apply for grants by submitting a detailed proposal.</p>
          </div>
          {/* Step 3: Evaluation */}
          <div className="bg-gradient-to-r from-[#1bdfff08] to-[#6777ff08] via-[#0098fb08] via-50 rounded-2xl p-8 w-full max-w-[360px] md:w-[360px] min-h-[280px] relative">
            <div className="absolute border border-[#1bdfff] rounded-2xl inset-0 pointer-events-none"></div>
            <div className="flex items-center justify-center mb-4">
              <span className="text-[#121828] text-xl font-semibold">Evaluation</span>
            </div>
            <p className="text-sm text-[#121828] text-left">The community reviews and discusses the application.</p>
          </div>
          {/* Step 4: Approval */}
          <div className="bg-gradient-to-r from-[#1bdfff08] to-[#6777ff08] via-[#0098fb08] via-50 rounded-2xl p-8 w-full max-w-[360px] md:w-[360px] min-h-[280px] relative">
            <div className="absolute border border-[#1bdfff] rounded-2xl inset-0 pointer-events-none"></div>
            <div className="flex items-center justify-center mb-4">
              <span className="text-[#121828] text-xl font-semibold">Approval</span>
            </div>
            <p className="text-sm text-[#121828] text-left">Grants are awarded based on community voting.</p>
          </div>
          {/* Step 5: Disbursement & Oversight */}
          <div className="bg-gradient-to-r from-[#1bdfff08] to-[#6777ff08] via-[#0098fb08] via-50 rounded-2xl p-8 w-full max-w-[360px] md:w-[360px] min-h-[280px] relative">
            <div className="absolute border border-[#1bdfff] rounded-2xl inset-0 pointer-events-none"></div>
            <div className="flex items-center justify-center mb-4">
              <span className="text-[#121828] text-xl font-semibold">Disbursement & Oversight</span>
            </div>
            <p className="text-sm text-[#121828] text-left">Approved projects receive funding in stages (if applicable), with transparent reporting requirements to ensure accountability.</p>
          </div>
        </div>
        <p className="mt-12 text-lg text-black text-center max-w-5xl mx-auto">
          Grants may support a wide range of initiatives — from developer tools and applications, to educational resources, community events, and research. By funding these projects, XAO DAO empowers individuals and teams to contribute to the growth, utility, and adoption of the XRPL.
        </p>
      </div>
    </section>
  );
}